export default __webpack_public_path__ + "static/lifeplugin-659ebe032f3fca1dee56df5d52cc38cd.png";